export const UI_SYMBOL_SPRITE_PATH = '/assets/ui/ui-symbols.svg';

export const UI_SYMBOL_NAMES = [
  'room-safe',
  'room-boss',
  'room-normal-enemy',
  'room-elite-enemy',
  'room-treasure',
  'room-npc',
  'room-trap',
  'room-secret',
  'room-teleporter',
  'room-empty',
  'room-unknown',
  'element-physical',
  'element-water',
  'element-fire',
  'element-wind',
  'element-earth',
  'element-lightning',
  'element-dark',
  'element-light',
  'status-stun',
  'status-freeze',
  'status-paralysis',
  'status-poison',
  'status-burn',
  'status-weaken',
  'status-fear',
  'status-invulnerable',
  'status-elemental-immunity',
  'status-power-up',
  'action-settings',
  'action-audio-on',
  'action-audio-off',
  'action-save',
  'action-load',
  'action-delete-save',
  'action-reset',
  'action-inventory',
  'action-skills',
  'action-items',
  'action-combat-log',
  'action-flee',
  'action-close',
  'action-expand',
  'stat-strength',
  'stat-intelligence',
  'stat-dexterity',
  'stat-luck',
  'resource-health',
  'resource-mana',
  'resource-exp',
  'currency-gold',
  'objective-marker',
] as const;

export type UiSymbolName = (typeof UI_SYMBOL_NAMES)[number];
